import { Component } from '@angular/core';
import { WizEventManager } from '@wizeoo/akm-component-lib';
import { AlkEvent } from '../../../framework/events/alk.event';
import { IWidget } from '../../../manager/widgets/i-widget';
import { ALK_EVENT_TYPE } from '../../../model/enums';
import { ConnectVO } from '../../../vo/core/connect.vo';


@Component({
  selector: 'connect-button',
  templateUrl: './connect-button.html'
})
export class ConnectButton {
  public data: ConnectVO; // datas from owner
  public widget: IWidget;
  public doConnect():void {
    // signale au widget une demande connect
    WizEventManager.dispatchEvent(this.widget, new AlkEvent(ALK_EVENT_TYPE.WIDGET_CONNECT_CALL, this.data));
  }

}
